import Vue from 'vue';

// MIGRATE: Migrate this to the store and get rid of the event bus pattern
export const EventBus = new Vue();
